import React from "react";
import { useTranslation } from "react-i18next";
import CountUp from "../ui/CountUp";
import NetworkBackground from "../effects/NetworkBackground";

const STATS = [
  { key: "clients", value: 30, suffix: "+" },
  { key: "satisfaction", value: 98, suffix: "%" },
  { key: "projects", value: 50, suffix: "+" },
];

// Still circuit image with the same live node network as the hero drawn over it.
const StatsStrip = () => {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden bg-ink text-white isolate">
      <div
        className="absolute inset-0 -z-10 bg-cover bg-left-top"
        style={{ backgroundImage: "url(/images/stats-circuit.svg)" }}
        aria-hidden="true"
      />
      <div
        className="absolute inset-0 -z-10 bg-[radial-gradient(ellipse_at_center,rgba(10,10,10,0)_0%,rgba(10,10,10,0.55)_100%)]"
        aria-hidden="true"
      />
      <NetworkBackground fade="none" className="-z-10" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24 grid grid-cols-3 gap-3 sm:gap-6 text-center">
        {STATS.map((s) => (
          <div
            key={s.key}
            className="rounded-2xl sm:rounded-3xl border border-white/15 bg-white/[0.06] backdrop-blur-md px-2 py-6 sm:px-6 sm:py-9 shadow-[0_30px_60px_-30px_rgba(0,0,0,0.8)]"
          >
            <div className="text-[clamp(1.9rem,5vw,3.25rem)] font-extrabold tracking-[-0.03em] leading-none text-white [text-shadow:0_0_24px_rgba(244,63,94,0.75)]">
              <CountUp value={s.value} suffix={s.suffix} />
            </div>
            <div className="mt-3 text-xs sm:text-sm text-white/80">{t(`stats.${s.key}`)}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StatsStrip;
